<section class="space-y-3" aria-live="polite">
  <h2 class="text-xl font-medium">{{ content().title }}</h2>
  <p class="text-gray-700">{{ content().description }}</p>
  <p role="status" class="rounded border border-gray-200 bg-gray-50 p-4 text-sm">
    Preview only. Financial actions are not available on this page yet.
  </p>
</section>
